import * as React from 'react';

import { StoreApi } from 'zustand';

import { FilterItemCheckbox } from '@notino/react-styleguide';
import { WishlistFiltrationGroupType } from '@notino/shared/definitions/types';

import { MultiSelectWrapper } from './styled';
import { useMultiSelectList } from './useMultiSelectList';

type Props = {
  groupType: WishlistFiltrationGroupType;
  store: StoreApi<{
    selectedItems: Array<{
      name: string;
      navigationValue: number;
    }>;
  }>;
};

export const MultiSelectList = ({ groupType, store }: Props) => {
  const { filter, isChecked, onChange } = useMultiSelectList({
    groupType,
    store,
  });

  return (
    <MultiSelectWrapper>
      {(filter?.items ?? []).map((item) => (
        <FilterItemCheckbox
          key={item.navigationValue}
          count={item.count}
          isChecked={isChecked(item)}
          onChange={(checked) => onChange(!checked, item)} // why the fuk is "checked" reversed?
        >
          {item.name}
        </FilterItemCheckbox>
      ))}
    </MultiSelectWrapper>
  );
};
